import script from "./MpesaContribution.vue?vue&type=script&setup=true&lang=js"
export * from "./MpesaContribution.vue?vue&type=script&setup=true&lang=js"

import "./MpesaContribution.vue?vue&type=style&index=0&id=2a9e4856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9e4856"]])

export default __exports__